import React from 'react';

import CN from './DialogMessage.module.scss';

const DialogMessage = ({ children }) => (
  <div data-bem="DialogMessage" className={CN.component}>
    {children}
  </div>
);

// noinspection JSUnusedGlobalSymbols
export default DialogMessage;
